import { isEmpty } from '@/common/js/utils'

export default {
  methods: {
    // 验证方法
    validate() {
      if (!this.verify) return

      // 推荐理由校验
      if (this.description === '推荐理由') {
        const len = this.value.length

        if (len === 2 || len === 0) {
        } else {
          this.msg = '请选择两个推荐理由或者不选'
          return
        }
      }

      // 必填
      if (this.required && isEmpty(this.value)) {
        if (this.sceneId === 3 && this.name === 'cover') return
        this.msg = `${this.description}不能为空`
        this.$emit('verify', { name: this.name, val: false })
        return
      }

      // 长度
      if (this.max && this.max < this.len) {
        this.msg = `${this.description}超过字符限制`
        this.$emit('verify', { name: this.name, val: false })
        return
      }
      if (this.required && this.min && this.min > this.len) {
        this.msg = `${this.description}未满足字符限制`
        this.$emit('verify', { name: this.name, val: false })
        return
      }

      // 验证
      if (this.pattern) {
        const regx = new RegExp(this.pattern)
        if (!regx.test(this.title)) {
          this.msg = `${this.description}不是有效的值`
          this.$emit('verify', { name: this.name, val: false })
          return
        }
      }

      // 图片与视频
      if (['vertical', 'horizontal', 'video', 'image'].includes(this.name)) {
        const field = this.name === 'image' ? 'image_token' : 'photo_id'
        const item = this.source.filter((ret) => ret[field] === this.value).pop()
        if (item) {
          const { file_size, width, height } = item
          if (file_size > this.size * 1024) {
            this.msg = `${this.description}超过文件大小限制`
            this.$emit('verify', { name: this.name, val: false })
            return
          }
          // if (width !== this.width || height !== this.height) {
          //   this.msg = `${this.description}不符合文件尺寸限制`
          //   this.$emit('verify', { name: this.name, val: false })
          //   return
          // }
        } else {
          this.msg = `${this.description}找不到文件对应的资源信息`
          this.$emit('verify', { name: this.name, val: false })
          return
        }
      }

      if (['cover'].includes(this.name)) {
        const item = this.source.filter((ret) => ret.image_token === this.value).pop()
        if (item) {
          const { type, file_size, width, height, cover_size, cover_width, cover_height } = item
          // eslint-disable-next-line
          let fileSize, fileWidth, fileHeight
          if (type === 'video') {
            // 默认封面
            fileSize = cover_size
            fileWidth = cover_width
            fileHeight = cover_height
          } else {
            fileSize = file_size
            fileWidth = width
            fileHeight = height
          }
          if (fileSize > this.size * 1024) {
            this.msg = `${this.description}超过文件大小限制`
            this.$emit('verify', { name: this.name, val: false })
            return
          }
          // if ((fileWidth && fileWidth !== this.width) || (fileHeight && fileHeight !== this.height)) {
          //   this.msg = `${this.description}不符合文件尺寸限制`
          //   this.$emit('verify', { name: this.name, val: false })
          //   return
          // }
        } else {
          this.msg = `${this.description}找不到文件对应的资源信息`
          this.$emit('verify', { name: this.name, val: false })
          return
        }
      }

      this.msg = ''

      this.$emit('verify', { name: this.name, val: true })
    }
  },
  watch: {
    value() {
      this.$emit('change')
    },
    // 验证模式
    verify(nVal) {
      if (nVal) this.validate()
    }
  },
  data() {
    this.msg = ''
    return {
      msg: ''
    }
  }
}
